$('#por_programas').click(function () {
    $('#seleccionar_programas').toggleClass('d-none')
})
